export class LoginForm {
    public userId: string;
    public password: string;
    public reCaptchaToken: string;
    constructor() { }
}
